import Router from "app/Router";
import React from "react";
import Layout from "shared/ui";
import WithProviders from "./providers";
import "./App.css";
import "./i18n";

const App = () => {
  return (
    <Layout>
      <Router />
    </Layout>
  );
};

export default WithProviders(App);
